import { Module } from 'vuex';
import { Employee } from '@/api';

export interface EmployeeState {
  employee: Employee | null;
}

declare const EMPLOYEE: Employee | null;

export default {
  namespaced: true,
  state: () => {
    return { employee: EMPLOYEE };
  },
  getters: {
    get(state: EmployeeState) {
      return state.employee;
    }
  },
  mutations: {
    update(state: EmployeeState, employee: Employee | null) {
      state.employee = employee;
    }
  }
} as Module<EmployeeState, any>;
